/* KT Cart Drawer v2: one-tap adds from the cart drawer (matching wrap, pair another print),
   and re-mounting Shopify's express checkout buttons after the drawer re-renders. */
(function () {
  if (window.__ktCartInit) return;
  window.__ktCartInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Shopify's accelerated checkout web component renders once per element. When the theme
  // swaps the drawer's innerHTML, the new element can arrive un-upgraded; cloning it
  // forces the component to initialise again.
  function remountExpress() {
    var el = document.querySelector('#Cart-Drawer .kt-express shopify-accelerated-checkout-cart');
    if (!el) return;
    if (el.children.length > 0) return;
    var fresh = el.cloneNode(true);
    el.parentNode.replaceChild(fresh, el);
  }

  document.addEventListener('line-item:change:end', function () { setTimeout(remountExpress, 400); });
  document.addEventListener('cart-drawer:open', function () { setTimeout(remountExpress, 400); });

  var drawer = document.getElementById('Cart-Drawer');
  if (drawer && window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(remountExpress, 600);
    }).observe(drawer, { childList: true });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-kt-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var id = parseInt(btn.getAttribute('data-kt-add'), 10);
    if (!id) return;
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          btn.textContent = (result.data && result.data.description) ? 'Unavailable' : label;
          btn.removeAttribute('aria-busy');
          return;
        }
        try {
          var item = result.data && result.data.items ? result.data.items[0] : result.data;
          var payload = {
            event: 'kt_cart_upsell_add',
            kt_source: btn.getAttribute('data-kt-source') || 'cart',
            variant_id: id,
            product_title: item && item.product_title,
            price: item && item.price != null ? item.price / 100 : undefined
          };
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(payload);
          document.dispatchEvent(new CustomEvent('kt:upsell_add', { detail: payload }));
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'kt-cart' } }));
      })
      .catch(function () {
        btn.textContent = label;
        btn.removeAttribute('aria-busy');
      });
  });

  /* Keep Klaviyo popups out of the cart: close any open form when the drawer opens,
     and flag <body> so CSS hides forms that fire while the drawer is open. */
  if (drawer && window.MutationObserver) {
    var syncKlaviyo = function () {
      var open = drawer.classList.contains('active');
      document.body.classList.toggle('kt-cart-open', open);
      if (!open) return;
      var closers = document.querySelectorAll('button.klaviyo-close-form');
      for (var i = 0; i < closers.length; i++) { try { closers[i].click(); } catch (e) {} }
    };
    new MutationObserver(syncKlaviyo).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    syncKlaviyo();
  }
})();
